import { LoadableLazy } from '@confluence/loadable';

export const DeleteNestedPagesActionLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DeleteNestedPagesActionLoader" */ '../src/Delete/DeleteNestedPagesAction.tsx'
			)
		).DeleteNestedPagesAction,
});
